import type { ReactNode } from 'react'

/** Compare line with an optional warn-toned trailing marker. */
export function withMarker(base: string, marker: string | null): ReactNode {
  if (!marker) return base
  return (
    <>
      {base} <span className="stat-compare-warn">{marker}</span>
    </>
  )
}
